import React, { useEffect } from 'react'
import { MDBBtn } from 'mdb-react-ui-kit';

import style from './style.module.scss';
import { showPopup } from '../../../Containers/App/action';
import { connect, useDispatch } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectWallet } from '../../../Containers/Client/selector';
import ActiveText from '../../../Components/ActiveText';
import { saveWallet, setWallet } from '../../../Containers/Client/action';

function Wallet({wallet}) {
    const dispatch = useDispatch();
    const onClickConnect = () => {
        dispatch(showPopup({isOpen: true, content:  "wallet-list"}))   
    }
    const onSuccessDelete = () => {
        dispatch(setWallet(null))
    }
    const onClickDisconnect = () => {
        dispatch(saveWallet('delete', null, onSuccessDelete));
    }
    const renderComponent = () => {
        if(wallet){
            return (<div className={style.connectedWallet}>
                <div>Connected to </div>
                <ActiveText isSettings={true} isScanAddress={true} text={wallet}/>
                <MDBBtn className={`mt-2 ${style.btnDisconnect}`} onClick={onClickDisconnect} >Disconnect Walet</MDBBtn>
            </div>)
        } 
        
        return (
            <div>
                <p>You're not connected to any wallet</p>
                <MDBBtn className={`mt-2 ${style.defaultBtn}`} onClick={onClickConnect} >Connect Walet</MDBBtn>
            </div>
        );

    }
  return (
    <div className={style.container}>
        <div className={style.box}>
            {renderComponent()}
        </div>
    </div>
  )
}

const mapStateToProps = createStructuredSelector({
    wallet: selectWallet,
});

export default connect(mapStateToProps)(Wallet);